
import { Component, Vue, Prop } from "vue-property-decorator"
import { Formatting } from "../util/formatting"
const dateFormat = new Formatting.DateFormatting()

import moment from "moment"

import MyJobsQuery from "../graphql/job/myjobs.graphql"
import MyWorkReportsQuery from "../graphql/workreport/myworkreports.graphql"
import * as cdn from "@coredination/components"
import GroupsQuery from "@/graphql/group/groups.graphql"
import EntityEventSubscription from "@/graphql/subscription/entityevent.graphql"

@Component({
    components: {},
    apollo: {
        me: cdn.graphql.me,
        myJobs: {
            query: MyJobsQuery,
            variables() {
                return {
                    from: moment().startOf("day"),
                    to: moment()
                        .add(1, "days")
                        .startOf("day"),
                    states: this.defaultJobStates,
                    myWorkDay: true
                }
            },
            pollInterval: 300000
        },
        myWorkReports: {
            query: MyWorkReportsQuery,
            variables() {
                return {
                    from: moment().startOf("day"),
                    to: moment()
                        .add(1, "days")
                        .startOf("day")
                }
            },
            pollInterval: 300000
        },
        groups: GroupsQuery,
        $subscribe: {
            entityEvent: {
                query: EntityEventSubscription,
                result(result: any) {
                    const event = result.data.entityEvent
                    console.log("entity event", event.type, event.data)
                    if (this.shouldRefresh(event)) {
                        this.refresh()
                        return
                    }
                },
                skip() {
                    return this.inhibitSubscription
                }
            }
        },
    }
})
export default class MyWorkList extends Vue {
    myJobs = []
    myWorkReports = []
    me: any = {}
    groups?: any[]
    totalWorkDuration: number = 0
    totalDuration: number = 0
    @Prop() title?: string
    @Prop() empty?: string
    @Prop() unreported?: boolean
    @Prop({ default: () => {} }) readonly jobFilter!: any

    defaultJobStates: string[] = [
        "INITIAL",
        "PUBLISHED",
        "ASSIGNED",
        "SCHEDULED",
        "IN_TRANSIT",
        "ON_STATION",
        "STARTED",
        "PAUSED",
        "DAY_FINISHED",
        "FINISHED",
        "CANCELED"
    ]

    get inhibitSubscription() {
        return localStorage && !!localStorage.getItem("inhibitSubscription")
    }

    get items() {
        const items: any[] = []

        // First add jobs...
        if (this.myJobs) {
            for (const job of this.myJobs as any[]) {
                if (this.skipJob(job)) continue
                const myResource = job.resources ? (job.resources as any[]).find(
                    r => r && this.me && r.emailAddress == this.me.emailAddress
                ) : null
                let description = job.description
                if (description && description.length > 200) description = description.substring(0, 200)
                items.push({
                    title: job.title,
                    description,
                    jobUuid: job.uuid,
                    job,
                    reports: [],
                    workDuration: 0,
                    myState: myResource && myResource.state,
                    cssClass: myResource && myResource.state && "job-state-" + myResource.state.toLowerCase(),
                    icon: "work",
                    iconColor: "grey",
                    priorityIcon: job.priority == "URGENT" ? "whatshot" : job.priority == "HIGH" ? "arrow_upward" : job.priority == "LOW" ? "arrow_downward" : null,
                    priorityIconColor: job.priority == "URGENT" ? "#b94a48" : job.priority == "HIGH" ? "black" : job.priority == "LOW" ? "grey" : null,
                    routeDescription: this.getRouteDescription(job),
                    link: `/job/${job.uuid}`,
                    started: myResource && myResource.state === "STARTED",
                    doneItems: job.workItems && job.workItems.filter((item: any) => item.done)
                })
            }
        }

        // ..then reports
        if (this.myWorkReports && !this.unreported) {
            for (const report of this.myWorkReports as any[]) {
                let workDuration = 0
                let icon = "assignment_turned_in"
                if (report.workDuration) {
                    workDuration = report.workDuration
                } else {
                    for (const item of report.items) {
                        if (item.quantity && item.workHours && !item.addOn && item.unit === "HOURS") {
                            workDuration += item.quantity * 60
                        }
                    }
                }
                if (report.jobUuid) {
                    const jobItem = items.find(item => (item.jobUuid == report.jobUuid))
                    if (jobItem) {
                        jobItem.reports.push(report)
                        jobItem.workDuration += workDuration
                    }
                    continue
                }
                let title = report.jobTitle
                if (!title) {
                    title = ""
                    if (report.activityName) {
                        title += report.activityName
                    }
                    if (report.customerName) {
                        if (title.length > 0) title += ": "
                        title += report.customerName
                    }
                    if (report.customerProjectName) {
                        if (title.length > 0) title += ": "
                        title += report.customerProjectName
                    }
                }
                const link = "/workreport/" + (report.type && report.type === "ABSENCE" ? "absence/" : "") + report.uuid
                items.push({
                    title,
                    description: report.description,
                    reports: [report],
                    workDuration,
                    icon,
                    link: link,
                    cssClass: report.type && "report-type-" + report.type.toLowerCase()
                })
            }
        }

        // Sum up work duration from items
        this.totalDuration = this.totalWorkDuration = 0
        for (const item of items) {
            if (item.workDuration) {
                this.totalDuration += item.workDuration
                this.totalWorkDuration += item.workDuration
            } else if (item.job) {
                const duration = this.getJobDuration(item.job)
                if (duration) this.totalDuration += duration
            }
        }

        // Figure out sort time
        for (const item of items) {
            if (item.job) {
                item.sortTime = this.getJobSortTime(item.job)
            }
            if (item.reports) {
                if (!item.sortTime) {
                    const report = item.reports.find((report: any) => report.startTime)
                    if (report) item.sortTime = moment(report.startTime).unix()
                }
                if (!item.sortTime) {
                    const report = item.reports.find((report: any) => report.endTime)
                    if (report) item.sortTime = moment(report.endTime).unix()
                }
                if (!item.sortTime) {
                    const today = moment().startOf("day")
                    for (const report of item.reports) {
                        const creation = moment(report.creationTimeStamp)
                        if (Math.abs(creation.diff(today, "hours")) <= 24) {
                            item.sortTime = creation.unix()
                            break
                        }
                    }
                }
                if (!item.sortTime && item.reports.length > 0) {
                    item.sortTime = moment(item.reports[0].workDate).unix()
                }
            }
            if (!item.sortTime && item.job && item.job.creationTimeStamp) {
                item.sortTime = moment(item.job.creationTimeStamp).unix()
            }
        }
        return items.sort((a, b) => a.sortTime - b.sortTime || this.weightedPriority(b) - this.weightedPriority(a))
    }

    weightedPriority(item: any): number {
        if (!item.job) return 0
        let priority: string = item.job.priority
        switch (priority) {
            case 'LOW':
                return -1
            case 'HIGH':
                return 1
            case 'URGENT':
                return 2
            default:
                return 0
        }
    }

    formatSortTime(item: any) {
        if (item.job && item.job.allDay) return ""
        if (item.sortTime) {
            let time = null
            if (item.job && item.sortTime === Infinity) {
                time = moment.unix(this.getJobSortTime(item.job)).format("HH:mm")
            } else {
                time = moment.unix(item.sortTime).format("HH:mm")
                if (!item.job && time == "00:00") return ""
            }
            return time
        }
        return ""
    }

    getJobSortTime(job: any) {
        let time: any
        if (job.startTime) time = moment(job.startTime).unix()
        else if (job.startedTimeStamp) time = moment(job.startedTimeStamp).unix()
        else if (job.endTime) time = moment(job.endTime).unix()
        else if (job.endedTimeStamp) time = moment(job.endedTimeStamp).unix()
        return time
    }

    getJobDuration(job: any) {
        // TODO if I haven't canceled
        if (job.duration) return job.duration
        if (job.startTime && job.endTime) {
            return (moment(job.endTime).unix() - moment(job.startTime).unix()) / 60
        }
    }

    briefLeft(item: any) {
        if (!item.job) return
        let brief: string = ""
        if (item.job.forms!.length > 0) {
            let completed: number = item.job.forms.filter((form: any) => form.formState === "COMPLETE").length
            brief += completed + "/" + item.job.forms.length + " " + this.$t("_customForms")
        }
        return brief
    }

    briefRight(item: any) {
        if (!item.job) return
        let brief: string = ""
        // TODO to be implemented once job list representation contains workitems (core update necessary)
        // if (item.job.workItems!.length > 0) {
        //     let completed: number = item.job.workItems.filter((workItem: any) => workItem.done).length
        //     brief += completed + "/" + item.job.workitems.length + " " + this.$t("_workItemsFinished")
        // }
        return brief
    }

    formatDuration(minutes: number) {
        return dateFormat.duration(minutes)
    }

    getGroupPrefix(id: number) {
        if (id) {
            let stringId = id.toString()
            if (this.groups) {
                let matchingGroup = this.groups.find(element => element.id == stringId)
                if (matchingGroup) return matchingGroup.prefix
            }
        }
        return ""
    }

    getRouteDescription(job: any) {
        const destinations = job.destinations
        if (destinations && destinations.length > 0) {
            var text
            if (destinations.length == 1) {
                if (destinations[0].location) text = destinations[0].location.placeName
            } else {
                for (var i = 1; i < destinations.length; i++) {
                    var destination = destinations[i]
                    if (destination.location && destination.location.placeName) {
                        text = destination.location.placeName
                        break
                    }
                }
                if (destinations.length > 2 && text) text += " (+" + (destinations.length - 2) + ")"
            }
            return text
        }
    }

    shouldRefresh(entityEvent: any) {
        let entity: any = entityEvent.data
        let entityClass: string = entity.entityClass
        if (!['WorkReport', 'Job'].includes(entityClass))
            return false
        let jobsAndReports: any[] = [...this.myJobs, ...this.myWorkReports]
        if (jobsAndReports.find(jobOrReport => entity.uuid === jobOrReport.uuid))
            return true
        // this refreshes even if the job/report isn't "today", might not be a very good solution,
        // but without this no newly assigned jobs are fetched
        if (entity.userId === this.me!.id)
            return true
        if (entity.jobResourceUserIds)
            return entity.jobResourceUserIds.includes(parseInt(this.me!.id));
        return false
    }

    refresh() {
        console.log("refreshing my work list")
        if (this.$apollo.queries.myJobs && typeof this.$apollo.queries.myJobs.refetch == "function")
            this.$apollo.queries.myJobs.refetch()
        if (this.$apollo.queries.myWorkReports && typeof this.$apollo.queries.myWorkReports.refetch == "function")
            this.$apollo.queries.myWorkReports.refetch()
    }

    itemClass(item: any) {
        return {
            [item.cssClass]: true,
        }
    }

    skipJob(job: any) {
        if (this.jobFilter) {
            for (const [key, value] of Object.entries(this.jobFilter)) {
                if (job[key] != value) return true
            }
        }
        if (this.unreported) {
            for (const resource of job.resources) {
                if (resource.userId == this.me.id && !resource.reported) return false
            }
            return true
        }
        return false
    }
}
